<template>
  <div class="list-group list-group-escape-container">
    <router-link
        v-for="partner of getPartners()"
        :to="{ name: 'partner', params: { id: partner.id }}"
        class="list-group-item list-group-item-action list-group-item-with-icon"
        v-bind:key="partner.id"
    >
      <div>
        <strong>{{ partner.title }}</strong>
        <div class="small text-muted">{{ partner.streetAddress }}</div>
      </div>
      <Icon icon-name="arrow-ios-forward-outline" icon-class="text-muted-more"></Icon>
    </router-link>
  </div>
</template>

<script>
import Icon from '@shared/components/Icon'
import PartnersMixin from '@shared/mixins/PartnersMixin'

export default {
  name: 'PartnersList',
  components: { Icon },
  mixins: [PartnersMixin]
}
</script>
